<style>
/*card vista prods */
.card-item {
    width: 300px;
    /* Tamaño fijo para la tarjeta */
    margin: 10px;
    /* Márgenes alrededor de la tarjeta */
    padding: 10px;
    /* Espaciado interno de la tarjeta */
    display: flex;
    flex-direction: column;
    align-items: center;
    /* Centra el contenido horizontalmente */
    justify-content: space-between;
    height: 100%;
}

.card-title {
    font-size: 22px;
    /* Tamaño de fuente para el título */
}

card-title,
.card-text {
    margin-bottom: 5px;
    /* Espaciado inferior para el título y el texto */
}

.product-image {
    flex-grow: 1;
    /* Permitir que la imagen ocupe el espacio disponible */
}

.product-image img {
    max-width: 100%;
    height: auto;
    width: 100%;
    /* Asegura que la imagen ocupe el ancho completo */
}

.card-text {
    font-size: 12px;
    /* Tamaño de fuente para el texto */
    margin-top: 5px;
    /* Márgen superior del texto */
    margin-bottom: 5px;
    /* Márgen inferior del texto */
}

.product-line {
    font-size: 16px;
    /* Ajusta el tamaño de la fuente según tus preferencias */
}

.product-image img {
    max-width: 100%;
    /* Establecer el tamaño máximo como el 100% del contenedor */
    height: auto;
    /* Puedes ajustar estas medidas según tus necesidades específicas */
    max-height: 200px;
    /* Por ejemplo, establecer una altura máxima */
}

.card-img {
    width: 100%;
    height: 100px;
    /* Altura fija para todas las imágenes */
}
</style>

<template>

    <div class="container" style="margin-top: 1%;" v-if="prodnuevos.length > 0">
        <div class="col-md-12">
            <h2 class="text-center mb-3">
                <i class="fas fa-star" style="color: #06283c;"></i>
                &nbsp; PRÓXIMAMENTE
            </h2>
            <p style="margin: 0;color:#333;"><b>Llegarán próximamente </b></p>
            <hr style="color:#06283c;">
        </div>
        <!-- Iteramos sobre los productos y creamos filas de tarjetas -->
        <div class="row">
            <div v-for="(producto, index) in prodnuevos" :key="index" class="col-lg-4 col-md-6 col-sm-12">
                <div class="card border-0">
                    <div class="row no-gutters  mt-5" v-if="(index % 6) < 3">
                        <!-- Columna izquierda para imagen o información del producto -->
                        <div class="col-md-6 d-flex justify-content-center align-items-center">
                            <img v-bind:src="producto.producto.PicturesUrl[4] ? producto.producto.PicturesUrl[4].sm : 'img/display/Placeholder.png'"
                                alt="Producto Image" style="height: 150px;">
                        </div>
                        <!-- Columna derecha para imagen o información del producto -->
                        <div class="col-md-6">
                            <div>
                                <router-link :to="{ name: 'detalleProducto', query: { claveprod: producto.items } }"
                                    style="border: none;color:#06283c; text-decoration: none; color: inherit;">
                                    <div class="card-body">
                                        <h5 class="card-title">{{ producto.items }}</h5>
                                        <p class="card-text">{{ producto.linea }}</p>
                                        <p class="card-text">{{ producto.descripcion }}</p>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="row no-gutters  mt-5" v-else>
                        <div class="col-md-6 ">
                            <router-link :to="{ name: 'detalleProducto', query: { claveprod: producto.items } }"
                                style="border: none;color:#06283c; text-decoration: none; color: inherit;">
                                <h5 class="card-title">{{ producto.items }}</h5>
                            </router-link>
                            <p class="card-text">{{ producto.linea }}</p>
                            <p class="card-text">{{ producto.descripcion }}</p>
                        </div>
                        <div class="col-md-6  d-flex justify-content-center align-items-center">
                            <img v-bind:src="producto.producto.PicturesUrl[4] ? producto.producto.PicturesUrl[4].sm : 'img/display/Placeholder.png'"
                                alt="Producto Image" style="height: 150px;">
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-md-4">
                <div class="row no-gutters mt-5">
                    <div class="col-md-6">
                        <router-link
                            style="font-size:22px;border: none;color:#06283c; text-decoration: none; color: inherit;"
                            :to="{ name: 'ListBolletin' }">
                            <h5 class="card-title">Boletín Completo</h5>
                            <p class="card-text">Detalles y Descarga</p>
                        </router-link>

                    </div>
                    <div class="col-md-6  d-flex justify-content-center align-items-center">
                        <img v-bind:src="'img/display/pdf.png'" alt="Producto Image" style="height: 150px;">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        currentIndex: 0,
        prodnuevos: [],
        loading: true,

    }),
    methods: {
        llenadatos() {
            this.loading = true;
            axios.get('/api/ProdsNew')
                .then(response => {
                    this.prodnuevos = response.data?.items ?? []
                })
                .catch(error => {
                    // Lógica para manejar errores
                    console.error(error);

                }).finally(() => {
                    this.loading = false; // Indicar que la carga de datos ha terminado
                });

        },
        // ... otros métodos existentes ...
    },
    mounted() {
        this.llenadatos();
    },
    computed: {

    },
};
</script>